/**
 * Returns true if the 403 is from the rovo dev require payment details
 */
export function isRovoDevPaymentDetailsRequiredError(error: {
    message?: string;
    response?: { data?: { paymentMethodsPath?: string } };
}): boolean {
    // signup-ccp.service throws a ForbiddenException with a paymentMethodsPath
    if (typeof error?.response?.data?.paymentMethodsPath === "string") {
        return true;
    }
    const errorResponse = error?.message?.trim();
    if (!errorResponse) return false;

    // different browsers may have different error shapes
    const errorBody = errorResponse.startsWith("Forbidden")
        ? errorResponse.substring(9).trim()
        : errorResponse;

    try {
        // extract paymentMethodsPath from error body
        const parsed = JSON.parse(errorBody) as { paymentMethodsPath?: string };
        return typeof parsed?.paymentMethodsPath === "string";
    } catch {
        return false;
    }
}
